import React from "react";
import Footer from "../Footer";
import Hero from "../Hero";
import VideoSection from "../VideoSection";
import "../home/home.css";

function Home() {
  return (
    <main>
      <Hero />
      <VideoSection />
      <Footer />
    </main>
  );
}

export default Home;
